import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

// Public pages
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Services from './components/Services';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SiteDocumentTitle from './components/SiteDocumentTitle';

// Admin pages
import AdminLogin from './pages/Admin/Login';
import AdminLayout from './pages/Admin/Layout';
import AdminDashboard from './pages/Admin/Dashboard';
import ContentEditor from './pages/Admin/ContentEditor';
import ProjectsManager from './pages/Admin/ProjectsManager';
import ServicesManager from './pages/Admin/ServicesManager';
import PricingManager from './pages/Admin/PricingManager';
import CrushShyDashboard from './pages/Admin/CrushShy/CrushShyDashboard';
import CrushShyUsers from './pages/Admin/CrushShy/CrushShyUsers';
import CrushShyReports from './pages/Admin/CrushShy/CrushShyReports';
import CrushShyVerifications from './pages/Admin/CrushShy/CrushShyVerifications';
import CrushShySettings from './pages/Admin/CrushShy/CrushShySettings';
import CrushShyLanding from './pages/Public/CrushShyLanding';
import CrushShyInvite from './pages/Public/CrushShyInvite';
import CrushShyRdv from './pages/Public/CrushShyRdv';
import { CrushShyPrivacy, CrushShyTerms } from './pages/Public/CrushShyLegal';

import './App.css';

// Public site wrapper
const PublicSite = () => (
  <>
    <SiteDocumentTitle />
    <Header />
    <main>
      <Hero />
      <About />
      <Projects />
      <Services />
      <Pricing />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <div className="App min-h-screen bg-[#0a0a0b] text-white">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<PublicSite />} />
              <Route path="/crushshy" element={<CrushShyLanding />} />
              <Route path="/crushshy/privacy" element={<CrushShyPrivacy />} />
              <Route path="/crushshy/terms" element={<CrushShyTerms />} />
              <Route path="/crushshy/invite" element={<CrushShyInvite />} />
              <Route path="/crushshy/rdv" element={<CrushShyRdv />} />
              
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="content" element={<ContentEditor />} />
                <Route path="projects" element={<ProjectsManager />} />
                <Route path="services" element={<ServicesManager />} />
                <Route path="pricing" element={<PricingManager />} />
                <Route path="socials" element={<ContentEditor />} />
                <Route path="crushshy" element={<Navigate to="/admin/crushshy/dashboard" replace />} />
                <Route path="crushshy/dashboard" element={<CrushShyDashboard />} />
                <Route path="crushshy/users" element={<CrushShyUsers />} />
                <Route path="crushshy/reports" element={<CrushShyReports />} />
                <Route path="crushshy/verifications" element={<CrushShyVerifications />} />
                <Route path="crushshy/settings" element={<CrushShySettings />} />
              </Route>
            </Routes>
            <Toaster />
          </div>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
